import { Space, Typography } from "antd";
import { OutgoingTransitionIcon } from "../outgoingTransitionIcon/outgoingTransitionIcon";
import { IncomingTransitionIcon } from "../incomingTransitionIcon/incomingTransitionIcon";
import { Circle } from "../../../../../common/components/circle/circle";

const { Text } = Typography;

export const WorkflowLegend = () => {
  return (
    <Space size="middle" wrap>
      <Space>
        <Circle color="var(--blue-100)" />
        <Text>Selected</Text>
      </Space>

      <Space>
        <IncomingTransitionIcon />
        <Text>Incoming Transitions</Text>
      </Space>

      <Space>
        <OutgoingTransitionIcon />
        <Text>Outgoing Transitions</Text>
      </Space>
    </Space>
  );
};
